export const getRoot = (state) => state.ui.cardOnboardingMVP2;

export const getFetchingPinwheelToken = (state) =>
    getRoot(state).fetchingPinwheelToken;

export const getPinwheelErrors = (state) => getRoot(state).pinwheelErrors;

export const getAmountToCharge = (state) => getRoot(state).amountToCharge;
